import Service from './Service';
import { createApi } from '@stilingue/st-auth-utils';
import { error401Handler } from '@/utils/error';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class PerformanceService extends Service {
  constructor(gateway) {
    const api = createApi('/performance', gateway, {
      authNotFound: () => true,
      error401Handler,
    });
    super(api, { afterParser });

    this.api.http.defaults.timeout = 300000;
  }

  facebookComparisonKeymetrics(params = {}) {
    return this.find({
      ...params,
      url: '/facebook/comparison/keymetrics',
    });
  }

  reportCallsQuantity(params = {}) {
    return this.find({
      ...params,
      url: '/report/calls_quantity',
    });
  }

  metricsOverview(params = {}) {
    return this.find({
      ...params,
      url: '/page/overview',
    });
  }

  metricsFanEvolution(params = {}) {
    return this.find({
      ...params,
      url: '/page/fan_evolution',
    });
  }

  cases(params = {}) {
    return this.find({
      ...params,
      url: '/sac/feed',
    });
  }

  engagedUsers(params) {
    return this.find({
      ...params,
      url: '/engaged-users',
    });
  }

  userPosts(params) {
    return this.find({
      ...params,
      url: '/user-posts',
    });
  }

  reportAvgTime(params = {}) {
    return this.find({
      ...params,
      url: '/report/avg_time_distribution',
    });
  }

  performanceByTyme(params) {
    return this.find({
      ...params,
      url: '/report/activity_colaborator',
    });
  }
}

export default new PerformanceService(gateway);
